import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import 'rxjs/add/operator/map';
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';

@Injectable()
export class GeneralService {
    config: any;
    public logo_login: String;
    public boton_home_logo: String;
    public nombre_empresa: String;
    public logo_impresion: String;
    public logo_impresion_height: String;
    public impresion_tabla_header_color: String;
    public impresion_tabla_header_color_contrast: String;
    public color_caracteristico: String;
    public firma_impresion: String;
    public footer_impresion: String;
    public favicon: string;
    public firma_email_color: String;
    public firma_email_direccion: any;
    public firma_email_provincia: String
    public firma_email_pais: String;
    public firma_email_telefono: String;
    public firma_email_web: String;
    public firma_email_imagenes: any;
    public web_index_contadores_color: String;
    public imagen_fondo: String;
    public permisos: any;
    public webserver: String;
    public web: string;
    public cliente_id: number;

    constructor(
        private http: Http,
    ) {
    }
    getGeneralesLocal() {
        return this.http.get('./assets/_env.json')
            .toPromise()
            .then((data: any) => {
                data = JSON.parse(data._body);
                this.config = data;
                let imagenes = data.data.imagenes;
                this.logo_login = imagenes.filter(img => img.nombre == 'logo_login').map(im => im.base64);
                this.boton_home_logo = imagenes.filter(img => img.nombre == 'boton_home_logo').map(im => im.base64);
                this.logo_impresion = imagenes.filter(img => img.nombre == 'logo_impresion').map(im => im.base64);
                this.logo_impresion_height = imagenes.filter(img => img.nombre == 'logo_impresion').map(im => im.height);
                this.nombre_empresa = data.data.cliente.nombre;
                this.impresion_tabla_header_color = data.data.cliente.impresion_tabla_header_color;
                this.impresion_tabla_header_color_contrast = data.data.cliente.impresion_tabla_header_color_contrast;
                this.color_caracteristico = data.data.cliente.color_caracteristico;
                this.firma_impresion = imagenes.filter(img => img.nombre == 'firma_impresion').map(im => im.base64);
                this.footer_impresion = imagenes.filter(img => img.nombre == 'footer_impresion').map(im => im.base64);
                this.favicon = imagenes.filter(img => img.nombre == 'favicon').map(im => im.base64);
                this.firma_email_color = data.data.cliente.firma_email_color;
                this.firma_email_direccion = data.data.cliente.firma_email_direccion;
                this.firma_email_provincia = data.data.cliente.firma_email_provincia;
                this.firma_email_pais = data.data.cliente.firma_email_pais;
                this.firma_email_telefono = data.data.cliente.firma_email_telefono;
                this.firma_email_web = data.data.cliente.firma_email_web;
                this.firma_email_imagenes = data.data.firma_email_imagenes;
                this.web_index_contadores_color = data.data.cliente.web_index_contadores_color;
                this.imagen_fondo = data.data.cliente.imagen_fondo;
                this.permisos = data.data.permisos;
                this.webserver = data.data.cliente.webserver;
                this.web = data.data.cliente.web;
                this.cliente_id = data.data.cliente.id;
            })
            .catch((err: any) => {
                console.error(err, "OBTENIENDO GENERAL WEB SERVICE");
            });
    }
}